(function () {
  'use strict';

  /* ——— Shared cart UI (badges + toast) ——— */

  function updateCartBadges(count) {
    var n = Math.max(0, parseInt(String(count), 10) || 0);
    var headerLink = document.querySelector('a.cart-icon-link');
    var drawerCart = document.querySelector('.drawer__footer a[href*="/cart"]');

    function setBadge(link, inline) {
      if (!link) return;
      var badge = link.querySelector('.cart-badge');
      if (n === 0) {
        if (badge) badge.parentNode.removeChild(badge);
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = inline ? 'cart-badge cart-badge--inline' : 'cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      badge.textContent = String(n);
    }

    setBadge(headerLink, false);
    setBadge(drawerCart, true);
  }

  var cartToastTimer;

  function showCartNotification(message, isError) {
    var el = document.getElementById('cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'cart-toast';
      el.className = 'cart-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('cart-toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 4000);
  }

  function parseShopifyErrorPayload(data) {
    if (!data || typeof data !== 'object') return 'Something went wrong. Please try again.';
    if (data.description) return String(data.description);
    if (data.message) return String(data.message);
    return 'Something went wrong. Please try again.';
  }

  /* ——— Dismissible announcement bar ——— */

  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    var btn = document.querySelector('[data-announcement-dismiss]');
    if (!bar || !btn) return;

    if (sessionStorage.getItem('maui-announcement-dismissed') === '1') {
      bar.style.display = 'none';
      document.documentElement.style.setProperty('--announcement-height', '0px');
      return;
    }

    btn.addEventListener('click', function () {
      bar.style.opacity = '0';
      bar.style.transform = 'translateY(-100%)';
      sessionStorage.setItem('maui-announcement-dismissed', '1');

      setTimeout(function () {
        bar.style.display = 'none';
        document.documentElement.style.setProperty('--announcement-height', '0px');
      }, 300);
    });
  }

  /* ——— Mobile drawer (slides from right) ——— */

  function initDrawer() {
    var drawer   = document.querySelector('[data-drawer]');
    var overlay  = document.querySelector('[data-drawer-overlay]');
    var toggles  = document.querySelectorAll('[data-drawer-toggle]');
    var closeBtn = document.querySelector('[data-drawer-close]');
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].setAttribute('aria-expanded', 'true');
      }
      if (closeBtn) closeBtn.focus();
    }

    function resetDrawerNavAccordions() {
      var btns = drawer.querySelectorAll('[data-drawer-nav-accordion]');
      for (var j = 0; j < btns.length; j++) {
        btns[j].setAttribute('aria-expanded', 'false');
        btns[j].classList.remove('is-open');
        var sid = btns[j].getAttribute('aria-controls');
        var sp = sid ? document.getElementById(sid) : null;
        if (sp) {
          sp.hidden = true;
          sp.classList.remove('is-open');
        }
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      for (var i = 0; i < toggles.length; i++) {
        toggles[i].setAttribute('aria-expanded', 'false');
      }
      resetDrawerNavAccordions();
    }

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function () {
        drawer.classList.contains('is-open') ? close() : open();
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ——— Mobile drawer: nested menu accordion ——— */

  function initDrawerNavAccordion() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    var triggers = drawer.querySelectorAll('[data-drawer-nav-accordion]');
    if (triggers.length === 0) return;

    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) {
        var btn = e.currentTarget;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var id = btn.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          btn.classList.remove('is-open');
          if (panel) {
            panel.hidden = true;
            panel.classList.remove('is-open');
          }
          return;
        }

        var all = drawer.querySelectorAll('[data-drawer-nav-accordion]');
        for (var j = 0; j < all.length; j++) {
          if (all[j] === btn) continue;
          all[j].setAttribute('aria-expanded', 'false');
          all[j].classList.remove('is-open');
          var oid = all[j].getAttribute('aria-controls');
          var op = oid ? document.getElementById(oid) : null;
          if (op) {
            op.hidden = true;
            op.classList.remove('is-open');
          }
        }

        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        if (panel) {
          panel.hidden = false;
          panel.classList.add('is-open');
        }
      });
    }
  }

  /* ——— Sticky header: shadow + hide on scroll down / show on scroll up ——— */

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var ticking = false;
    var lastY = window.scrollY || 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function update() {
      var y = window.scrollY || 0;

      if (y > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      if (!reduceMotion.matches) {
        if (y < 48) {
          header.classList.remove('is-header-hidden');
        } else if (y > lastY) {
          header.classList.add('is-header-hidden');
        } else if (y < lastY) {
          header.classList.remove('is-header-hidden');
        }
      } else {
        header.classList.remove('is-header-hidden');
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ——— Product image gallery ——— */

  function initProductGallery() {
    var carousel = document.querySelector('[data-product-carousel]');
    var thumbs   = document.querySelectorAll('[data-thumb-target]');
    if (!carousel || thumbs.length === 0) return;

    var slides = carousel.querySelectorAll('[data-slide]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var targetId = thumb.getAttribute('data-thumb-target');

        slides.forEach(function (s) { s.classList.remove('is-active'); });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });

        var target = carousel.querySelector('[data-image-id="' + targetId + '"]');
        if (target) target.classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });

    /* Zoom: transform-origin follows cursor */
    var zoomContainers = document.querySelectorAll('[data-zoom]');
    zoomContainers.forEach(function (container) {
      container.addEventListener('mousemove', function (e) {
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top)  / rect.height) * 100;
        var img = container.querySelector('img');
        if (img) img.style.transformOrigin = x + '% ' + y + '%';
      });

      container.addEventListener('mouseleave', function () {
        var img = container.querySelector('img');
        if (img) img.style.transformOrigin = 'center center';
      });
    });
  }

  /* ——— Quantity selector (+/−) ——— */

  function initQuantitySelectors() {
    document.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
      if (wrap.closest('[data-cart-page]')) return;
      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus  = wrap.querySelector('[data-qty-plus]');
      if (!input) return;

      var min = parseInt(input.getAttribute('min') || '1', 10);

      if (minus) {
        minus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || min;
          input.value = Math.max(min, val - 1);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || min;
          input.value = val + 1;
        });
      }
    });
  }

  /* ——— Product tabs ——— */

  function initProductTabs() {
    var container = document.querySelector('[data-product-tabs]');
    if (!container) return;

    var buttons = container.querySelectorAll('[data-tab-btn]');
    var panels  = container.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');

        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        var panel = container.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) {
          panel.classList.add('is-active');
          panel.hidden = false;
        }
      });
    });
  }

  /* ——— Variant selector ——— */

  function initVariantSelector() {
    var jsonEl = document.querySelector('[data-product-json]');
    var form   = document.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;

    var data     = JSON.parse(jsonEl.textContent);
    var variants = data.variants;

    var optionSelects = form.querySelectorAll('[data-option-index]');
    var variantInput  = form.querySelector('[data-variant-id]');
    var priceEl       = document.querySelector('[data-current-price]');
    var compareEl     = document.querySelector('[data-compare-price]');
    var badgeEl       = document.querySelector('[data-save-badge]');
    var addBtn        = form.querySelector('[data-add-btn]');
    var carousel      = document.querySelector('[data-product-carousel]');
    var thumbs        = document.querySelectorAll('[data-thumb-target]');

    if (optionSelects.length === 0) return;

    function getSelectedOptions() {
      var opts = [];
      optionSelects.forEach(function (s) { opts.push(s.value); });
      return opts;
    }

    function findVariant(selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updatePage(variant) {
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-unavailable-text') || 'Unavailable';
        }
        return;
      }

      /* Hidden input */
      if (variantInput) variantInput.value = variant.id;

      /* Price */
      if (priceEl) priceEl.textContent = variant.price_formatted;

      /* Compare-at price */
      if (compareEl) {
        if (variant.compare_at_price > 0 && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      /* Save badge */
      if (badgeEl) {
        if (variant.compare_at_price > 0 && variant.compare_at_price > variant.price) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badgeEl.textContent = 'Save ' + pct + '%';
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }

      /* Button */
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-sold-out-text') || 'Sold out';
        }
      }

      /* Gallery — jump to variant image */
      if (variant.featured_image_id && carousel) {
        var slides = carousel.querySelectorAll('[data-slide]');
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        var target = carousel.querySelector('[data-image-id="' + variant.featured_image_id + '"]');
        if (target) target.classList.add('is-active');

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        var thumb = document.querySelector('[data-thumb-target="' + variant.featured_image_id + '"]');
        if (thumb) thumb.classList.add('is-active');
      }

      /* URL */
      if (window.history && window.history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ variant: variant.id }, '', url);
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var selected = getSelectedOptions();
        var variant  = findVariant(selected);
        updatePage(variant);
      });
    });
  }

  /* ——— Add to cart: /cart/add.js (PDP + product cards) ——— */

  function getVariantIdFromForm(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return null;
    var id = parseInt(String(idInput.value).trim(), 10);
    return isNaN(id) ? null : id;
  }

  function getQuantityFromForm(form) {
    var qInput = form.querySelector('input[name="quantity"]');
    if (!qInput) return 1;
    var q = parseInt(String(qInput.value).trim(), 10);
    if (isNaN(q) || q < 1) q = 1;
    return q;
  }

  function isProductAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.hasAttribute('data-product-form')) return true;
    if (form.classList.contains('product-card__form')) return true;
    return false;
  }

  function initAddToCartAjax() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isProductAddForm(form)) return;

      var sub = e.submitter;
      if (form.hasAttribute('data-product-form')) {
        if (sub && sub.getAttribute('name') !== 'add') return;
      }

      var variantId = getVariantIdFromForm(form);
      if (!variantId) return;

      e.preventDefault();

      var qty = getQuantityFromForm(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: qty }]
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, status: res.status, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            showCartNotification(parseShopifyErrorPayload(result.data), true);
            return null;
          }
          return fetch('/cart.js', {
            headers: { Accept: 'application/json' }
          }).then(function (r) {
            if (!r.ok) throw new Error('cart');
            return r.json();
          });
        })
        .then(function (cart) {
          if (!cart || typeof cart.item_count === 'undefined') return;
          updateCartBadges(cart.item_count);
          showCartNotification('Added to cart! 🤙', false);
        })
        .catch(function () {
          showCartNotification('Could not add to cart. Please try again.', true);
        })
        .then(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  /* ——— Cart page: AJAX qty, remove, note (cart/change.js, cart/update.js) ——— */

  function parseMoneyFormatEl(root) {
    var el = root.querySelector('[data-shop-money-format]');
    if (!el || !el.textContent) return '{{amount}}';
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return '{{amount}}';
    }
  }

  function formatMoneyCents(cents, formatStr) {
    var fmt = formatStr || '{{amount}}';
    var amount = (Math.round(Number(cents)) / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(Number(cents) / 100));
    return fmt
      .replace(/\{\{\s*amount_no_decimals\b[^}]*\}\}/gi, amountNoDecimals)
      .replace(/\{\{\s*amount\b[^}]*\}\}/gi, amount);
  }

  function initCartPage() {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;

    var moneyFormat = parseMoneyFormatEl(root);
    var threshold = parseInt(root.getAttribute('data-free-shipping-threshold') || '0', 10) || 0;

    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    var msgEl = root.querySelector('[data-free-shipping-message]');
    var fillEl = root.querySelector('[data-free-shipping-fill]');

    function setBusy(lineEl, busy) {
      if (!lineEl) return;
      lineEl.classList.toggle('is-updating', !!busy);
    }

    function updateFreeShipping(cart) {
      if (!threshold || !msgEl || !fillEl) return;
      var total = cart.total_price;
      var pct = threshold > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 0;
      fillEl.style.width = pct + '%';
      var earnedMsg = root.getAttribute('data-free-earned-msg');
      var awayTmpl = root.getAttribute('data-free-away-tmpl');
      if (total >= threshold && earnedMsg) {
        msgEl.textContent = earnedMsg;
      } else if (awayTmpl) {
        var remaining = Math.max(0, threshold - total);
        msgEl.textContent = awayTmpl.split('__AMT__').join(formatMoneyCents(remaining, moneyFormat));
      }
    }

    function applyCartResponse(cart) {
      if (!cart || typeof cart.item_count === 'undefined') {
        window.location.reload();
        return;
      }

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoneyCents(cart.total_price, moneyFormat);
      }

      updateFreeShipping(cart);

      var keysSeen = {};
      cart.items.forEach(function (item) {
        keysSeen[item.key] = true;
        var line = null;
        var allLines = root.querySelectorAll('[data-cart-line]');
        for (var i = 0; i < allLines.length; i++) {
          if (allLines[i].getAttribute('data-line-key') === item.key) {
            line = allLines[i];
            break;
          }
        }
        if (!line) return;
        var totalNodes = line.querySelectorAll('[data-line-total]');
        var unitNodes = line.querySelectorAll('[data-line-unit]');
        var input = line.querySelector('[data-qty-input]');
        if (input) input.value = String(item.quantity);
        var lineCents = item.final_line_price != null ? item.final_line_price : item.line_price;
        var unitCents = item.final_price != null ? item.final_price : item.price;
        var ft = formatMoneyCents(lineCents, moneyFormat);
        var fu = formatMoneyCents(unitCents, moneyFormat);
        totalNodes.forEach(function (n) { n.textContent = ft; });
        unitNodes.forEach(function (n) { n.textContent = fu; });
      });

      root.querySelectorAll('[data-cart-line]').forEach(function (line) {
        var key = line.getAttribute('data-line-key');
        if (key && !keysSeen[key]) {
          line.parentNode.removeChild(line);
        }
      });

      updateCartBadges(cart.item_count);
    }

    function postCartChange(lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error('cart');
            err.payload = data;
            throw err;
          }
          return data;
        });
      });
    }

    root.addEventListener('click', function (e) {
      var removeLink = e.target.closest && e.target.closest('a.cart-line-card__remove-link');
      if (!removeLink || !root.contains(removeLink)) return;
      e.preventDefault();
      var line = removeLink.closest('[data-cart-line]');
      var lineKey = line && line.getAttribute('data-line-key');
      if (!lineKey) {
        window.location.href = removeLink.getAttribute('href');
        return;
      }
      setBusy(line, true);
      postCartChange(lineKey, 0)
        .then(function (cart) {
          applyCartResponse(cart);
        })
        .catch(function (err) {
          var msg = err && err.payload ? parseShopifyErrorPayload(err.payload) : 'Could not remove item.';
          showCartNotification(msg, true);
          window.location.reload();
        })
        .then(function () {
          setBusy(line, false);
        });
    });

    root.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var wrap = line.querySelector('[data-qty-wrap]');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      var minus = wrap && wrap.querySelector('[data-qty-minus]');
      var plus = wrap && wrap.querySelector('[data-qty-plus]');
      if (!input || !wrap) return;

      var lineKey = input.getAttribute('data-line-key') || line.getAttribute('data-line-key');
      if (!lineKey) return;

      var min = parseInt(input.getAttribute('min') || '0', 10);

      function commitQty(nextVal) {
        var q = parseInt(String(nextVal), 10);
        if (isNaN(q) || q < min) q = min;
        input.value = String(q);
        setBusy(line, true);
        postCartChange(lineKey, q)
          .then(function (cart) {
            applyCartResponse(cart);
          })
          .catch(function (err) {
            var msg = err && err.payload ? parseShopifyErrorPayload(err.payload) : 'Could not update quantity.';
            showCartNotification(msg, true);
            window.location.reload();
          })
          .then(function () {
            setBusy(line, false);
          });
      }

      if (minus) {
        minus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 0;
          commitQty(Math.max(min, val - 1));
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 0;
          commitQty(val + 1);
        });
      }

      input.addEventListener('change', function () {
        commitQty(input.value);
      });
    });

    var noteEl = root.querySelector('[data-cart-note]');
    var noteTimer;
    if (noteEl) {
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ note: noteEl.value })
          }).catch(function () { /* silent */ });
        }, 500);
      });
    }
  }

  /* ——— Collection sort & price filter (preserve URL query params) ——— */

  function initCollectionPage() {
    var sortSelect = document.querySelector('[data-collection-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (sortSelect.value) {
          url.searchParams.set('sort_by', sortSelect.value);
        } else {
          url.searchParams.delete('sort_by');
        }
        window.location.href = url.toString();
      });
    }

    var priceForm = document.querySelector('[data-collection-price-form]');
    if (priceForm) {
      priceForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var gteName = priceForm.getAttribute('data-param-gte') || 'filter.v.price.gte';
        var lteName = priceForm.getAttribute('data-param-lte') || 'filter.v.price.lte';
        var minEl = priceForm.querySelector('[data-price-min]');
        var maxEl = priceForm.querySelector('[data-price-max]');
        var url = new URL(window.location.href);

        url.searchParams.delete(gteName);
        url.searchParams.delete(lteName);

        function toCents(val) {
          if (val == null || String(val).trim() === '') return '';
          var n = parseFloat(String(val).replace(/[^0-9.]/g, ''), 10);
          if (isNaN(n) || n < 0) return '';
          return String(Math.round(n * 100));
        }

        var gte = minEl ? toCents(minEl.value) : '';
        var lte = maxEl ? toCents(maxEl.value) : '';
        if (gte !== '') url.searchParams.set(gteName, gte);
        if (lte !== '') url.searchParams.set(lteName, lte);

        window.location.href = url.toString();
      });
    }
  }

  /* ——— Customer newsletter forms (AJAX) ——— */

  function showNewsletterAjaxSuccess(form) {
    var msg = document.createElement('p');
    msg.className = 'newsletter-ajax-success';
    msg.setAttribute('role', 'status');
    msg.textContent = 'Mahalo! You\'re in the loop 🌺';
    form.style.display = 'none';
    form.parentNode.insertBefore(msg, form);
  }

  function newsletterResponseLooksSuccessful(html) {
    if (html.indexOf('newsletter-section__success') !== -1) return true;
    if (html.indexOf('newsletter-success') !== -1) return true;
    return false;
  }

  function newsletterResponseHasErrors(html) {
    if (html.indexOf('class="errors"') !== -1) return true;
    if (html.indexOf("class='errors'") !== -1) return true;
    if (html.indexOf('form-error') !== -1) return true;
    return false;
  }

  function initNewsletterAjax() {
    var forms = document.querySelectorAll('form.newsletter-section__form, form.site-footer__newsletter-form');
    if (forms.length === 0) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        var action = form.getAttribute('action') || '/contact';

        fetch(action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        })
          .then(function (res) {
            return res.text();
          })
          .then(function (html) {
            if (newsletterResponseLooksSuccessful(html)) {
              showNewsletterAjaxSuccess(form);
              return;
            }
            if (newsletterResponseHasErrors(html)) {
              showCartNotification('Please check your email and try again.', true);
              return;
            }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.querySelector('.newsletter-section__success, .newsletter-success')) {
              showNewsletterAjaxSuccess(form);
            } else if (doc.querySelector('.errors, .form-errors')) {
              showCartNotification('Please check your email and try again.', true);
            } else {
              showCartNotification('Could not confirm signup. Please try again.', true);
            }
          })
          .catch(function () {
            showCartNotification('Something went wrong. Please try again.', true);
          })
          .then(function () {
            if (btn) btn.disabled = false;
          });
      });
    });
  }

  /* ——— Lazy / deferred images: loaded class + optional data-src ——— */

  function initLazyImageReveal() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markLoaded(img) {
      if (reduce) {
        img.classList.add('loaded');
        return;
      }
      img.classList.add('loaded');
    }

    document.querySelectorAll('img[data-src]').forEach(function (img) {
      img.classList.add('img-lazy-reveal');
    });

    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (!img.classList.contains('img-lazy-reveal')) {
        img.classList.add('img-lazy-reveal');
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var img = entry.target;
          var ds = img.getAttribute('data-src');
          if (ds) {
            img.src = ds;
            if (img.getAttribute('data-srcset')) {
              img.srcset = img.getAttribute('data-srcset');
            }
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
          }
          obs.unobserve(img);
        });
      }, { rootMargin: '80px', threshold: 0.01 });

      document.querySelectorAll('img[data-src]').forEach(function (img) {
        io.observe(img);
      });
    } else {
      document.querySelectorAll('img[data-src]').forEach(function (img) {
        var ds = img.getAttribute('data-src');
        if (ds) img.src = ds;
        img.removeAttribute('data-src');
      });
    }

    document.querySelectorAll('img.img-lazy-reveal').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
      } else {
        img.addEventListener('load', function onLoad() {
          img.removeEventListener('load', onLoad);
          markLoaded(img);
        });
        img.addEventListener('error', function onErr() {
          img.removeEventListener('error', onErr);
          markLoaded(img);
        });
      }
    });
  }

  /* ——— Scroll-triggered .fade-in-section ——— */

  function initFadeInSections() {
    var els = document.querySelectorAll('.fade-in-section');
    if (els.length === 0) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ——— Collection grid: staggered card reveal ——— */

  function initCollectionCardReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var grid = document.querySelector('.collection-grid');
    if (!grid || !('IntersectionObserver' in window)) return;

    var cards = grid.querySelectorAll('.product-card');
    if (cards.length === 0) return;

    document.documentElement.classList.add('js-collection-stagger');

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.disconnect();
        cards.forEach(function (card, i) {
          window.setTimeout(function () {
            card.classList.add('is-visible');
          }, i * 55);
        });
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });

    io.observe(grid);
  }

  /* ——— Contact FAQ: accordion + height-friendly animation ——— */

  function initContactFaq() {
    var items = document.querySelectorAll('.contact-faq__item');
    if (items.length === 0) return;

    items.forEach(function (detail) {
      var ans = detail.querySelector('.contact-faq__answer');
      if (!ans) return;
      ans.style.overflow = 'hidden';
      ans.style.transition = 'max-height 0.4s ease';
      if (!detail.open) {
        ans.style.maxHeight = '0px';
      } else {
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }

      detail.addEventListener('toggle', function () {
        if (detail.open) {
          items.forEach(function (other) {
            if (other !== detail && other.open) {
              other.open = false;
            }
          });
          window.requestAnimationFrame(function () {
            ans.style.maxHeight = ans.scrollHeight + 'px';
          });
        } else {
          ans.style.maxHeight = '0px';
        }
      });
    });
  }

  /* ——— Bootstrap ——— */

  function init() {
    initAnnouncementBar();
    initDrawer();
    initDrawerNavAccordion();
    initStickyHeader();
    initProductGallery();
    initQuantitySelectors();
    initProductTabs();
    initVariantSelector();
    initAddToCartAjax();
    initCollectionPage();
    initCartPage();
    initNewsletterAjax();
    initLazyImageReveal();
    initFadeInSections();
    initCollectionCardReveal();
    initContactFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
